import {AsyncInlineError} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

class NotifyAutenticationPasswordUseCase extends UseCase {
  constructor({service, gigyaEventFactory}) {
    super({service, gigyaEventFactory})

    this._service = service
    this._gigyaEventFactory = gigyaEventFactory
  }

  @AsyncInlineError()
  async execute({event}) {
    const gigyaEventValueObject = this._gigyaEventFactory({
      eventName: event.eventName,
      screenSet: event.screen || '',
      formData: event.response || {}
    })

    const [serviceError] = await this._service.execute({
      gigyaEventAuthenticationValueObject: gigyaEventValueObject
    })

    if (serviceError) return Promise.reject(serviceError)

    return Promise.resolve()
  }
}

export default NotifyAutenticationPasswordUseCase
